import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect, useDispatch} from 'react-redux';
import {checkLoadCellError} from 'stores/business/loadCellErrorBusiness';

import {showIsBusyModal} from 'stores/business/commonModalBusiness';
import {clearInstrumentProcess} from 'stores/business/instrumentStatusBusiness';
import FormattedHTMLMessage from '../../components/FormattedHTMLMessage';
import {CurrentStateEnum, FastRobotErrorcode, Feedback, SignalREvent, ViewMode} from '../../constants/dataEnum';
import './TrayCalibrationContainer.scss';
import {fastCommonActuatorAPIErrorHandler} from '../../stores/business/errorHandlerBusiness';
import withIntl from '../../lib/withIntl';
import PageLayout from '../../components/Layout/PageLayout';
import TrayCalibrationHeader from './TrayCalibrationHeader';
import {
  selectDeckInsertById,
  setDeckInsertXYZValue,
  setCurrentPosisition,
  setTrayData,
} from '../../stores/actions/trayCalibrationStateAction';
import {showLoading, hideLoading, changeView, showSnackbar} from '../../stores/actions/appStateAction';
import {showModal, hideModal} from '../../stores/actions/modalStateAction';
import {saveState} from '../../stores/business/stateBusiness';
import {
  checkTouchProbeAndEjectTray,
  getCurrentPosition,
  safeAlignToDeckInsertWithExtendedProbe,
  safeTouchProbeRetract,
  setCalibrationData,
  isTouchProbeExpanded,
  getInstrumentStatus,
} from '../../stores/business/instrumentBusiness';
import {
  checkOngoingCalibration,
  extendTouchProbe,
  getCurrentPos,
  onAutoCalibration,
  retractTouchProbe,
} from '../../stores/business/trayCalibrationBusiness';
import {
  showFailedToRunCalibrationModal,
  showModalAutoCalibrationConfirmation,
} from '../../stores/business/modalStateBusinessAction';
import {fastRecovery} from '../../stores/business/recoveryBusiness';

import TrayCalibrationInfoPanel from './TrayCalibrationInfoPanel';
import TrayCalibrationControlPanel from './TrayCalibrationControlPanel';

function mapStateToProps(state) {
  return {
    trayCalibrationState: state.trayCalibrationState,
    signalrState: state.signalrState,
    prevViewMode: state.appState.prevViewMode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    recoveryBusinessFastRecovery: bindActionCreators(fastRecovery, dispatch),
    instrumentBusinessGetCurrentPosition: bindActionCreators(getCurrentPosition, dispatch),
    instrumentBusinessSafeTouchProbeRetract: bindActionCreators(safeTouchProbeRetract, dispatch),
    instrumentBusinessSetCalibrationData: bindActionCreators(setCalibrationData, dispatch),
    instrumentBusinessIsTouchProbeExpanded: bindActionCreators(isTouchProbeExpanded, dispatch),
    onFastCommonActuatorAPIErrorHandler: bindActionCreators(fastCommonActuatorAPIErrorHandler, dispatch),
    onSelectDeckInsertById: bindActionCreators(selectDeckInsertById, dispatch),
    onSetDeckInsertXYZValue: bindActionCreators(setDeckInsertXYZValue, dispatch),
    onShowLoading: bindActionCreators(showLoading, dispatch),
    onHideLoading: bindActionCreators(hideLoading, dispatch),
    onShowModal: bindActionCreators(showModal, dispatch),
    onHideModal: bindActionCreators(hideModal, dispatch),
    onChangeView: bindActionCreators(changeView, dispatch),
    stateBusinessSaveState: bindActionCreators(saveState, dispatch),
    trayCalibrationStateActionSetCurrentPosisition: bindActionCreators(setCurrentPosisition, dispatch),
    trayCalibrationStateActionSetTrayData: bindActionCreators(setTrayData, dispatch),
    trayCalibrationStateActionsafeAlignToDeckInsertWithExtendedProbe: bindActionCreators(
      safeAlignToDeckInsertWithExtendedProbe,
      dispatch,
    ),
    instrumentBusinessEjectTray: bindActionCreators(checkTouchProbeAndEjectTray, dispatch),
    trayCalibrationBusinessGetCurrentPos: bindActionCreators(getCurrentPos, dispatch),
    trayCalibrationBusinessOnAutoCalibration: bindActionCreators(onAutoCalibration, dispatch),
    trayCalibrationBusinessRetractTouchProbe: bindActionCreators(retractTouchProbe, dispatch),
    trayCalibrationBusinessExtendTouchProbe: bindActionCreators(extendTouchProbe, dispatch),
    trayCalibrationBusinessCheckOngoingCalibration: bindActionCreators(checkOngoingCalibration, dispatch),
    onShowModalAutoCalibrationConfirmation: bindActionCreators(showModalAutoCalibrationConfirmation, dispatch),
    modalStateBusinessActionShowFailedToRunCalibrationModal: bindActionCreators(
      showFailedToRunCalibrationModal,
      dispatch,
    ),
    appStateActionShowSnackbar: bindActionCreators(showSnackbar, dispatch),
  };
}

function TrayCalibrationContainer({
  trayCalibrationState,
  stateBusinessSaveState,
  prevViewMode,
  onSelectDeckInsertById,
  onFastCommonActuatorAPIErrorHandler,
  recoveryBusinessFastRecovery,
  instrumentBusinessGetCurrentPosition,
  instrumentBusinessSafeTouchProbeRetract,
  instrumentBusinessSetCalibrationData,
  instrumentBusinessEjectTray,
  instrumentBusinessIsTouchProbeExpanded,
  trayCalibrationBusinessCheckOngoingCalibration,
  onSetDeckInsertXYZValue,
  onShowLoading,
  onHideLoading,
  onShowModal,
  onHideModal,
  onChangeView,
  trayCalibrationStateActionSetCurrentPosisition,
  trayCalibrationStateActionSetTrayData,
  trayCalibrationStateActionsafeAlignToDeckInsertWithExtendedProbe,
  intl,
  trayCalibrationBusinessRetractTouchProbe,
  trayCalibrationBusinessExtendTouchProbe,
  trayCalibrationBusinessGetCurrentPos,
  trayCalibrationBusinessOnAutoCalibration,
  onShowModalAutoCalibrationConfirmation,
  modalStateBusinessActionShowFailedToRunCalibrationModal,
  appStateActionShowSnackbar,
}) {
  const dispatch = useDispatch();
  const [deckInsertID, setDeckInsertID] = useState(0);
  const [selectedDeckInsert, setSelectedDeckInsert] = useState(0);
  const [isCalibrated, setIsCalibrated] = useState(true);

  const {deckInserts, currentPosition, markerPosition} = trayCalibrationState;

  const deckInsertsRef = useRef(deckInserts);

  useEffect(() => {
    deckInsertsRef.current = deckInserts;
  }, [deckInserts]);

  useEffect(() => {
    // get current position on component did mount
    trayCalibrationBusinessGetCurrentPos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    trayCalibrationBusinessCheckOngoingCalibration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsCalibrated(true);
    // temporary disable marker position due to vision issue (zooming on camera)
    // if (!markerPosition) {
    //   setIsCalibrated(false);
    // }

    for (let iDeckInsert = 0; iDeckInsert < deckInserts.length; iDeckInsert += 1) {
      if (!deckInserts[iDeckInsert].isCalibrated) {
        setIsCalibrated(false);
      }
      if (deckInserts[iDeckInsert].isSelected) {
        setSelectedDeckInsert(deckInserts[iDeckInsert].id);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deckInserts, markerPosition]);

  const onAutoCalibrationHandler = async () => {
    const instrumentStatus = await dispatch(getInstrumentStatus());
    if (instrumentStatus?.currentState !== CurrentStateEnum.IDLE) {
      dispatch(showIsBusyModal());
      return;
    }

    const isLoadCellError = await dispatch(checkLoadCellError(null, onAutoCalibrationHandler));
    if (isLoadCellError) return;
    onShowModalAutoCalibrationConfirmation(trayCalibrationBusinessOnAutoCalibration);
  };

  const onRetractTouchProbeHandler = () => {
    onShowModalAutoCalibrationConfirmation(
      () => trayCalibrationBusinessRetractTouchProbe(fastCommonActuatorAPIErrorHandler),
      SignalREvent.SAFE_TOUCH_PROBE_RETRACT,
    );
  };
  const onExtendTouchProbeHandler = () => {
    onShowModalAutoCalibrationConfirmation(
      () => trayCalibrationBusinessExtendTouchProbe(fastCommonActuatorAPIErrorHandler),
      SignalREvent.SAFE_TOUCH_PROBE_EXTEND,
    );
  };

  const onClose = async () => {
    onShowLoading(
      intl.formatMessage({
        id: 'trayCalibrationContainer.loading.onRetractTouchProbe',
      }),
    );

    const response = await instrumentBusinessGetCurrentPosition();
    // eject tray if its position is not ejected
    if (response.y !== 0) {
      await instrumentBusinessEjectTray();
    }

    const isTouchProbeExpandedResponse = await instrumentBusinessIsTouchProbeExpanded();

    if (isTouchProbeExpandedResponse) {
      const safeTouchProbeRetractResponse = await instrumentBusinessSafeTouchProbeRetract();

      onHideLoading();

      if (safeTouchProbeRetractResponse !== FastRobotErrorcode.NoError) {
        onFastCommonActuatorAPIErrorHandler(safeTouchProbeRetractResponse);

        return;
      }
    } else {
      onHideLoading();
    }

    if (prevViewMode !== '' && prevViewMode !== ViewMode.RUNTIME_PREPARATION && prevViewMode !== ViewMode.RUNTIME) {
      onChangeView(prevViewMode);
    } else onChangeView(ViewMode.PROTOCOL_EDITOR);

    dispatch(clearInstrumentProcess());
  };

  function onSelectDeck(id) {
    const selectedDeck = deckInsertsRef.current.find((deck) => deck.id === id);
    if (selectedDeck) {
      // 03/18/19 (AS) : Change to get value from payload
      // this.setState({ xVal: selectedDeck.xPos, yVal: selectedDeck.yPos, zVal: selectedDeck.zPos });
      trayCalibrationStateActionSetCurrentPosisition(selectedDeck.calibrationData);
    }
    setDeckInsertID(id);
    onSelectDeckInsertById(id);

    // invoke 'AlignXYZ' command
    onShowLoading(
      intl.formatMessage({
        id: 'trayCalibrationContainer.loading.alignDeckInsert',
      }),
    );
    if (id !== 0) {
      console.log('AlignToDeckInsert id', id);
      trayCalibrationStateActionsafeAlignToDeckInsertWithExtendedProbe(id).then((response) => {
        onHideLoading();
        if (response !== FastRobotErrorcode.NoError && response !== FastRobotErrorcode.TrayUncalibrated) {
          onFastCommonActuatorAPIErrorHandler(
            response,
            () => onSelectDeck(id),
            () => {
              trayCalibrationBusinessGetCurrentPos();
              setSelectedDeckInsert(0);
              onSelectDeckInsertById(id, false);
            },
          );
        }
        stateBusinessSaveState();
      });
    } else {
      trayCalibrationBusinessGetCurrentPos();
    }
  }

  const onHoming = () => {
    recoveryBusinessFastRecovery(trayCalibrationBusinessGetCurrentPos, trayCalibrationBusinessGetCurrentPos);
  };

  // #region motion control pad
  const onClickMotionControlPadArrow = (response, axis) => {
    if (response.result === FastRobotErrorcode.NoError) {
      trayCalibrationStateActionSetCurrentPosisition({
        ...currentPosition,
        [axis]: parseFloat(response.position.toFixed(2)),
      });
    } else if (response.result === FastRobotErrorcode.ActuatorIllegalPos) {
      appStateActionShowSnackbar(
        Feedback.WARNING,
        intl.formatMessage({
          id: 'trayCalibrationContainer.notification.reachedMaximumLimit',
        }),
      );
    } else {
      onFastCommonActuatorAPIErrorHandler(response.result);
    }
  };

  const onSetValueMotionPad = () => {
    onShowLoading(
      intl.formatMessage({
        id: 'trayCalibrationContainer.loading.onSetValueMotionPad',
      }),
    );
    instrumentBusinessSetCalibrationData(deckInsertID, currentPosition?.x, currentPosition?.y, currentPosition?.z).then(
      (response) => {
        // set tray data
        trayCalibrationStateActionSetTrayData(response.tray);
        if (response.result === FastRobotErrorcode.NoError) {
          onSetDeckInsertXYZValue(deckInsertID, currentPosition?.x, currentPosition?.y, currentPosition?.z);
          if (deckInsertID > 0) {
            onSelectDeck(deckInsertID);
          }
        } else if (response.result === FastRobotErrorcode.MISALIGNMENT_TRAY) {
          // rollPitchYaw exceeds thresholdRPY
          modalStateBusinessActionShowFailedToRunCalibrationModal(
            response.tray.rollPitchYaw,
            response.tray.thresholdRPY,
          );
        } else {
          // failed
          onShowModal(
            intl.formatMessage({
              id: 'trayCalibrationContainer.modal.setCalibrationValueErrorMessage.title',
            }),
            <FormattedHTMLMessage id="trayCalibrationContainer.modal.setCalibrationValueErrorMessage.text" />,
            [
              {
                className: 'btn-lg',
                style: 'primary',
                handlerClick: () => {
                  onHideModal();
                },
                text: intl.formatMessage({
                  id: 'trayCalibrationContainer.modal.setCalibrationValueErrorMessage.firstButton',
                }),
              },
            ],
            () => onHideModal,
          );
        }

        onHideLoading();
      },
    );
  };
  // #endregion motion control pad

  return (
    <PageLayout>
      <PageLayout.Header>
        <TrayCalibrationHeader onAutoCalibration={onAutoCalibrationHandler} onClose={onClose} />
      </PageLayout.Header>
      <PageLayout.Content>
        <div className="tray-calibration-container">
          <TrayCalibrationInfoPanel
            trayCalibrationState={trayCalibrationState}
            isCalibrated={isCalibrated}
            selectedDeckInsert={false}
            intl={intl}
          />
          <TrayCalibrationControlPanel
            onRetractTouchProbe={onRetractTouchProbeHandler}
            onExtendTouchProbe={onExtendTouchProbeHandler}
            onSelectDeck={onSelectDeck}
            selectedDeckInsert={selectedDeckInsert}
            onHoming={onHoming}
            onSetValueMotionPad={onSetValueMotionPad}
            deckInsertID={deckInsertID}
            xVal={currentPosition?.x}
            yVal={currentPosition?.y}
            zVal={currentPosition?.z}
            onClickArrow={onClickMotionControlPadArrow}
          />
        </div>
      </PageLayout.Content>
    </PageLayout>
  );
}

TrayCalibrationContainer.propTypes = {
  trayCalibrationState: PropTypes.any.isRequired,
  prevViewMode: PropTypes.any.isRequired,
  onFastCommonActuatorAPIErrorHandler: PropTypes.func.isRequired,
  recoveryBusinessFastRecovery: PropTypes.func.isRequired,
  instrumentBusinessGetCurrentPosition: PropTypes.func.isRequired,
  instrumentBusinessSafeTouchProbeRetract: PropTypes.func.isRequired,
  instrumentBusinessSetCalibrationData: PropTypes.func.isRequired,
  instrumentBusinessEjectTray: PropTypes.func.isRequired,
  instrumentBusinessIsTouchProbeExpanded: PropTypes.func.isRequired,
  trayCalibrationBusinessCheckOngoingCalibration: PropTypes.func.isRequired,
  intl: PropTypes.any.isRequired,
  onSelectDeckInsertById: PropTypes.func.isRequired,
  onSetDeckInsertXYZValue: PropTypes.func.isRequired,
  onShowLoading: PropTypes.func.isRequired,
  onHideLoading: PropTypes.func.isRequired,
  onShowModal: PropTypes.func.isRequired,
  onHideModal: PropTypes.func.isRequired,
  onChangeView: PropTypes.func.isRequired,
  stateBusinessSaveState: PropTypes.func.isRequired,
  trayCalibrationStateActionSetCurrentPosisition: PropTypes.func.isRequired,
  trayCalibrationStateActionSetTrayData: PropTypes.func.isRequired,
  trayCalibrationStateActionsafeAlignToDeckInsertWithExtendedProbe: PropTypes.func.isRequired,
  trayCalibrationBusinessGetCurrentPos: PropTypes.func.isRequired,
  trayCalibrationBusinessOnAutoCalibration: PropTypes.func.isRequired,
  trayCalibrationBusinessRetractTouchProbe: PropTypes.func.isRequired,
  trayCalibrationBusinessExtendTouchProbe: PropTypes.func.isRequired,
  onShowModalAutoCalibrationConfirmation: PropTypes.func.isRequired,
  modalStateBusinessActionShowFailedToRunCalibrationModal: PropTypes.func.isRequired,
  appStateActionShowSnackbar: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(TrayCalibrationContainer));
